
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { ViewAnalytics } from "@/mixins";
import { MetadataKeys, VignetteRoutes } from "@/types";

const sessionModule = namespace("session");

@Component
export default class Welcome extends mixins(ViewAnalytics) {
  @sessionModule.Action("login")
  login!: () => void;

  // Override for PageTitle mixin
  pageName = "";

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAYWALLED_CONTENT_STATUS, "Public");
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Public Page");
    this.setAnalyticsMetadata(MetadataKeys.SITESECTION, "Public Pages");
    this.pushPageViewEvent();
  }

  getSignUpPageRoute(): VignetteRoutes {
    return VignetteRoutes.SignUp;
  }

  getContactPageRoute(): VignetteRoutes {
    return VignetteRoutes.Contact;
  }
}
